<template>
  <div class="content-body">
    <!-- row -->
    <div class="container-fluid">
      <div class="page-titles form-head d-flex flex-wrap justify-content-between align-items-center mb-4">
        <h2 class="text-black font-w600 mb-0 mr-auto mb-2 pr-3">Withdrawal</h2>
        <a v-if="tabToShow == 1" href="javascript:void(0)" class="btn btn-primary btn-rounded mr-3  mb-2" @click="$router.push({name: 'add-with-drawal-methods'})" >
          <i class="las la-file scale5 mr-3"></i>
          Add Method</a>
        <a v-if="tabToShow == 2" href="javascript:void(0)" class="btn btn-primary btn-rounded mr-3  mb-2" @click="$router.push({name: 'add-with-drawal-request'})" >
          <i class="las la-file scale5 mr-3"></i>
          Add Request</a>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">Withdrawal</h4>
            </div>
            <div class="card-body">
              <!-- Nav tabs -->
              <div class="default-tab">
                <ul class="nav nav-tabs" role="tablist">
                  <li class="nav-item" @click="tabToShow = 1" >
                    <a class="nav-link"  :class="tabToShow == 1 ? 'active' : ''" data-toggle="tab" href="#home"><i class="las la-filter"></i>Withdrawal Methods</a>
                  </li>
                  <li class="nav-item" @click="tabToShow = 2">
                    <a class="nav-link" :class="tabToShow == 2 ? 'active' : ''" data-toggle="tab" href="#profile"><i class="las la-poll-h"></i> Withdrawal Requests</a>
                  </li>
                </ul>
                <div class="tab-content">
                  <div class="tab-pane fade show " :class="tabToShow == 1 ? 'active' : ''" id="home" role="tabpanel">
                    <div class="pt-4">
                      <div class="table-responsive table-hover fs-14 card-table">
                        <CommonTable
                            url="v1/get-user-withdrawal-methods"
                            :tableHeaderValues="userTableHeaderValues"
                            :actions="userActions"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="tab-pane fade show" :class="tabToShow == 2 ? 'active' : ''" id="profile">
                    <div class="pt-4">
                      <div v-if="tab2sendCall"
                           class="card-body table-responsive p-0 table-striped table-hover table-bordered">
                        <CommonTable
                            url="v1/get-all-withdrawals"
                            :tableHeaderValues="tableHeaderValues"
                            :actions="actions"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <WithdrawalMethodModal :show="showModal" :data="selectedData" :index="selectedIndex"
                           @hide="showModal = false"></WithdrawalMethodModal>
    <WithdrawalRequestDetailModal :show="showWithdrawalRequestModal" :data="WithdrawalRequestSelectedData"
                                  :index="WithdrawalRequestSelectedIndex"
                                  @hide="showWithdrawalRequestModal = false"></WithdrawalRequestDetailModal>
  </div>

</template>

<script>

export default {
  data() {
    return {
      showModal: false,
      showWithdrawalRequestModal: false,
      selectedData: null,
      selectedIndex: 0,
      WithdrawalRequestSelectedData: null,
      WithdrawalRequestSelectedIndex: 0,
      withdrawalRequestSent: false,
      withdrawalMethodCallSent: false,
      tabToShow: 1,
      showWithdrawalMethodLogo: true,
      showWithdrawalRequestLogo: true,
      force : false,
      tab2sendCall:false,
      perPage: 0,
      tableHeaderValues: [
        {
          title: 'Method',
          valueKey: 'with_drawal_method.payment_method.name',
          html: true,
          alter: function (value){
            var html=''
            html = ` <a href="javascript:void()" class="badge badge-circle badge-success">${value}</a>`

            return html



          }
        },
        {
          title: 'Amount',
          valueKey: 'amount',
          html: true,
          alter: function(value) {
            var html=''
            html = `<span class="text-black fs-20 font-w600">${value/100}</span>`

            return html

          }
        },
        {
          title: 'Created',
          valueKey: 'created_at',
          alter: (value) => {
            return this.customFormatDateTime(value)
          }
        },
      ],
      actions: [
        {
          title: 'View Details',
          cta: (row, index) => {
            this.showAddEditWithdrawalrequestModal(row, index)
          }
        },
      ],
      userTableHeaderValues: [
        {
          title: 'Method',
          valueKey: 'payment_method.name',
          html: true,
          alter: function (value){
            var html=''
            if(value)
            html = ` <a href="javascript:void()" class="badge badge-circle badge-success">${value}</a>`

            return html



          }
        },
      ],
      userActions: [
        {
          title: 'View Details',
          cta: (row, index) => {
            this.showAddEditModal(row, index)
          }
        }
      ]
    }
  },
  mounted() {
    if (typeof (this.$route.params.tab) != 'undefined') {
      this.tab = this.$route.params.tab
    }
    if (this.tab == 2) {
      this.tabToShow = this.tab
    }
    setTimeout(()=>{
      this.tab2sendCall = true
    },1000)
  },
  methods: {
    showAddEditModal(data, index) {
      this.selectedData = data
      this.selectedIndex = index
      this.showModal = true
    },
    showAddEditWithdrawalrequestModal(data, index) {
      this.WithdrawalRequestSelectedData = data
      this.WithdrawalRequestSelectedIndex = index
      this.showWithdrawalRequestModal = true
    },
  },
  watch: {
    tabToShow(){

    }
  }
}
</script>

